import { PublisherPage } from "./PublisherPage";

export function Publisher() {
  return <PublisherPage />;
}
